import React from 'react';
import {
  Grid,
  Switch
} from '@material-ui/core';
import { InfoTooltip } from 'components';


const SwitchGrid = ({
  name,
  label,
  value,
  onChange,
  classes = '',
  isTooltip = false,
  tooltipTitle
}) => {
  return (
    <Grid container spacing={3} className="ml-2 mb-5 items-center">
      <Grid item xs={12} md={3}>
        {label}
      </Grid>
      <Grid item xs={12} md={5} className="text-right flex">
        <Switch
          color="primary"
          name={name}
          checked={value == '1'}
          onChange={(event) => onChange(event.target.checked ? '1' : '0')}
          className={classes}
        />
        {isTooltip &&
          <InfoTooltip title={tooltipTitle} />
        }
      </Grid>
    </Grid>
  );
};

export default SwitchGrid;
